// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Wrapper container for the cards */

.container {
  width: 1200px; 
  margin: 0 auto; 
  overflow: hidden; 

}
/* .homologation123{
  padding: 0;
} */
/* homoloation cards*/

.homologation-cards {
  display: flex;
  justify-content: space-around; /* Space between cards */
  align-items: center; /* Align items vertically */
  padding: 40px 10px; /* Spacing inside the banner */
  background: linear-gradient(#6EBA35, #10677A); /* Yellow to green gradient */
  border-radius: 0px; /* Rounded corners for the banner */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Slight shadow for the banner */
}

/*homologation card container*/
.homologation-card {
  width: 340px; 
  height: 500px; 
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/*homologation card first card*/
.homologation-card:first-child {
  display: flex;
  width: 28%;
  flex-direction: column;
  padding: 0;
  background: none;
  border: none;

}

/* Image fills the entire first card */
.homologation-card:first-child .image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.homologation-card:first-child img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures the image covers the card */
  
}

/* Specific styles for the first card */
.homologation-card.first-card {
  border: none; /* Remove border */
  margin-right: 0px;
}

.homologation-card.first-card .fill-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 30px;
  left: 20px;
  
  color: #0e0c0c;
  
  font-size: 30px;
  border-radius: 5px;
}

/* General image styles */
.image-wrapper {
  position: relative;
  width: 80%;
  height: 200px;
}
.homologation-card:nth-child(n+2) .image-wrapper {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center; 
  align-items: flex-start; 
  padding-top: 10px;
}
/* Specific styles for 1st card */
.homologation-card:nth-child(1) .card-image {
  width: 100%; 
  height: 100%; 
  object-fit: fill; 
}
.homologation-card:nth-child(n+2) .card-image {
  width: 250px; 
  height: 250px; 
  object-fit: contain; 
}
/* Specific styles for 2nd card */
.homologation-card:nth-child(2) .card-image {
  width: 350px; 
  height: 300; 
  object-fit: contain; 
  margin-top: 10px; 
}

/* Specific styles for 4th card */
.homologation-card:nth-child(4) .card-image {
  width: 200px; 
  height: 220; 
  object-fit: contain;
  margin-top: 10px; 
}


.card-image {
  width: 80%;
  height: 80%;
  object-fit: cover;
}

.resizable-image {
  object-fit: contain; 
}

/* Title and description */
.card-title {
  font-size: 20px;
  font-weight: bold;
  margin: 10px;
  color:#007e01;
}

.card-description {
  font-size: 15px;
  margin: 20px;
  flex-grow: 1;
    

}

/* Learn more section */
.learn-more-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 3cqmin;
}

.learn-more-line {
  width: 100%;
  height: 2px;
  background-color: rgb(202, 193, 193);
  margin-bottom: 10px;
}

.learn-more-btn {
  display: inline-block;
  padding: 8px 16px;
  font-size: 14px;
  color: white;
  background-color: #22b81d;
  border: none;
  border-radius: 5px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
}

.homologation-detail {
  text-align: center;
  padding: 20px;
}

.detail-image {
  max-width: 100%;
  height: auto;
}

.detail-title {
  font-size: 1rem;
  margin-top: 20px;
}

.detail-description {
  font-size: 1.2rem;
  color: #555;
  margin-top: 20px;
}

.back-button {
  background-color: #22b81d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 20px;
}

.back-button:hover {
  background-color: #0056b3;
}




.learn-more-btn:hover {
  background-color: #212724;
}


/* Title for the 2nd, 3rd, and 4th cards */
.homologation-card:nth-child(2) .card-title

 {
  color: #007e01; /* Set your desired color */
  font-weight: bold; /* Optional: Emphasize the title */
  font-size: 22px; /* Optional: Adjust font size */
  margin: 70% 10%;
  margin-top: 20%;
}
.homologation-card:nth-child(3) .card-title
{
  color: #007e01; /* Set your desired color */
  font-weight: bold; /* Optional: Emphasize the title */
  font-size: 22px; /* Optional: Adjust font size */
  margin: 120% 10%;
  margin-top: 20%;
}
.homologation-card:nth-child(4) .card-title
{
  color: #007e01; /* Set your desired color */
  font-weight: bold; /* Optional: Emphasize the title */
  font-size: 22px; /* Optional: Adjust font size */
  margin: 80% 10%;
  margin-top: 20%;
}
/* Title for the 2nd, 3rd, and 4th cards */
.homologation-card:nth-child(2) .card-description
 {
  font-size: 1.2rem;
  color: #555;
  margin-top: -60%;
}
.homologation-card:nth-child(3) .card-description
{
font-size: 1.2rem;
color: #555;
margin-top: -100%;
}
.homologation-card:nth-child(4) .card-description
{
font-size: 1.2rem;
color: #555;
margin-top: -60%;
}
/* Mobile styles */
@media (max-width: 768px) {
  .homologation-cards {
    flex-direction: column; /* Stack cards vertically */
    padding: 60px 30px;
  }

  .homologation-card {
    width: 100%; /* Full width for mobile */
    height: auto; /* Adjust height automatically */
    margin-bottom: 20px; /* Add spacing between cards */
  }

  .card-title {
    font-size: 20px; /* Smaller text */
  }

  .card-description {
    font-size: 16px;
  }

  .learn-more-btn {
    font-size: 12px;
    padding: 6px 12px;
  }
}

/* Tablet styles */
@media (min-width: 769px) and (max-width: 1024px) {
  .homologation-cards {
    flex-wrap: wrap; /* Allow wrapping */
    justify-content: center;
  }

  .homologation-card {
    width: 45%; /* Adjust card width */
    margin: 10px; /* Add spacing between cards */
  }

  .card-title {
    font-size: 25px; /* Adjust text size */
  }

  .card-description {
    font-size: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homologation/Homologation.css"],"names":[],"mappings":";AACA,oCAAoC;;AAEpC;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;;AAElB;AACA;;GAEG;AACH,qBAAqB;;AAErB;EACE,aAAa;EACb,6BAA6B,EAAE,wBAAwB;EACvD,mBAAmB,EAAE,2BAA2B;EAChD,kBAAkB,EAAE,8BAA8B;EAClD,6CAA6C,EAAE,6BAA6B;EAC5E,kBAAkB,EAAE,mCAAmC;EACvD,yCAAyC,EAAE,iCAAiC;AAC9E;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,YAAY;;AAEd;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,sCAAsC;;AAE3D;;AAEA,uCAAuC;AACvC;EACE,YAAY,EAAE,kBAAkB;EAChC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;;EAEV,cAAc;;EAEd,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA,iCAAiC;AACjC;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;;;AAGd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;;;;AAKA;EACE,yBAAyB;AAC3B;;;AAGA,0CAA0C;AAC1C;;;EAGE,cAAc,EAAE,2BAA2B;EAC3C,iBAAiB,EAAE,kCAAkC;EACrD,eAAe,EAAE,+BAA+B;EAChD,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,cAAc,EAAE,2BAA2B;EAC3C,iBAAiB,EAAE,kCAAkC;EACrD,eAAe,EAAE,+BAA+B;EAChD,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,cAAc,EAAE,2BAA2B;EAC3C,iBAAiB,EAAE,kCAAkC;EACrD,eAAe,EAAE,+BAA+B;EAChD,eAAe;EACf,eAAe;AACjB;AACA,0CAA0C;AAC1C;;EAEE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;;AAEA,iBAAiB;AACjB,WAAW;AACX,iBAAiB;AACjB;AACA;;AAEA,iBAAiB;AACjB,WAAW;AACX,gBAAgB;AAChB;AACA,kBAAkB;AAClB;EACE;IACE,sBAAsB,EAAE,2BAA2B;IACnD,kBAAkB;EACpB;;EAEA;IACE,WAAW,EAAE,0BAA0B;IACvC,YAAY,EAAE,gCAAgC;IAC9C,mBAAmB,EAAE,8BAA8B;EACrD;;EAEA;IACE,eAAe,EAAE,iBAAiB;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe,EAAE,mBAAmB;IACpC,uBAAuB;EACzB;;EAEA;IACE,UAAU,EAAE,sBAAsB;IAClC,YAAY,EAAE,8BAA8B;EAC9C;;EAEA;IACE,eAAe,EAAE,qBAAqB;EACxC;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["\n/* Wrapper container for the cards */\n\n.container {\n  width: 1200px; \n  margin: 0 auto; \n  overflow: hidden; \n\n}\n/* .homologation123{\n  padding: 0;\n} */\n/* homoloation cards*/\n\n.homologation-cards {\n  display: flex;\n  justify-content: space-around; /* Space between cards */\n  align-items: center; /* Align items vertically */\n  padding: 40px 10px; /* Spacing inside the banner */\n  background: linear-gradient(#6EBA35, #10677A); /* Yellow to green gradient */\n  border-radius: 0px; /* Rounded corners for the banner */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Slight shadow for the banner */\n}\n\n/*homologation card container*/\n.homologation-card {\n  width: 340px; \n  height: 500px; \n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/*homologation card first card*/\n.homologation-card:first-child {\n  display: flex;\n  width: 28%;\n  flex-direction: column;\n  padding: 0;\n  background: none;\n  border: none;\n\n}\n\n/* Image fills the entire first card */\n.homologation-card:first-child .image-wrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.homologation-card:first-child img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* Ensures the image covers the card */\n  \n}\n\n/* Specific styles for the first card */\n.homologation-card.first-card {\n  border: none; /* Remove border */\n  margin-right: 0px;\n}\n\n.homologation-card.first-card .fill-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-overlay {\n  position: absolute;\n  top: 30px;\n  left: 20px;\n  \n  color: #0e0c0c;\n  \n  font-size: 30px;\n  border-radius: 5px;\n}\n\n/* General image styles */\n.image-wrapper {\n  position: relative;\n  width: 80%;\n  height: 200px;\n}\n.homologation-card:nth-child(n+2) .image-wrapper {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center; \n  align-items: flex-start; \n  padding-top: 10px;\n}\n/* Specific styles for 1st card */\n.homologation-card:nth-child(1) .card-image {\n  width: 100%; \n  height: 100%; \n  object-fit: fill; \n}\n.homologation-card:nth-child(n+2) .card-image {\n  width: 250px; \n  height: 250px; \n  object-fit: contain; \n}\n/* Specific styles for 2nd card */\n.homologation-card:nth-child(2) .card-image {\n  width: 350px; \n  height: 300; \n  object-fit: contain; \n  margin-top: 10px; \n}\n\n/* Specific styles for 4th card */\n.homologation-card:nth-child(4) .card-image {\n  width: 200px; \n  height: 220; \n  object-fit: contain;\n  margin-top: 10px; \n}\n\n\n.card-image {\n  width: 80%;\n  height: 80%;\n  object-fit: cover;\n}\n\n.resizable-image {\n  object-fit: contain; \n}\n\n/* Title and description */\n.card-title {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 10px;\n  color:#007e01;\n}\n\n.card-description {\n  font-size: 15px;\n  margin: 20px;\n  flex-grow: 1;\n    \n\n}\n\n/* Learn more section */\n.learn-more-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin: 3cqmin;\n}\n\n.learn-more-line {\n  width: 100%;\n  height: 2px;\n  background-color: rgb(202, 193, 193);\n  margin-bottom: 10px;\n}\n\n.learn-more-btn {\n  display: inline-block;\n  padding: 8px 16px;\n  font-size: 14px;\n  color: white;\n  background-color: #22b81d;\n  border: none;\n  border-radius: 5px;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n}\n\n.homologation-detail {\n  text-align: center;\n  padding: 20px;\n}\n\n.detail-image {\n  max-width: 100%;\n  height: auto;\n}\n\n.detail-title {\n  font-size: 1rem;\n  margin-top: 20px;\n}\n\n.detail-description {\n  font-size: 1.2rem;\n  color: #555;\n  margin-top: 20px;\n}\n\n.back-button {\n  background-color: #22b81d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n.back-button:hover {\n  background-color: #0056b3;\n}\n\n\n\n\n.learn-more-btn:hover {\n  background-color: #212724;\n}\n\n\n/* Title for the 2nd, 3rd, and 4th cards */\n.homologation-card:nth-child(2) .card-title\n\n {\n  color: #007e01; /* Set your desired color */\n  font-weight: bold; /* Optional: Emphasize the title */\n  font-size: 22px; /* Optional: Adjust font size */\n  margin: 70% 10%;\n  margin-top: 20%;\n}\n.homologation-card:nth-child(3) .card-title\n{\n  color: #007e01; /* Set your desired color */\n  font-weight: bold; /* Optional: Emphasize the title */\n  font-size: 22px; /* Optional: Adjust font size */\n  margin: 120% 10%;\n  margin-top: 20%;\n}\n.homologation-card:nth-child(4) .card-title\n{\n  color: #007e01; /* Set your desired color */\n  font-weight: bold; /* Optional: Emphasize the title */\n  font-size: 22px; /* Optional: Adjust font size */\n  margin: 80% 10%;\n  margin-top: 20%;\n}\n/* Title for the 2nd, 3rd, and 4th cards */\n.homologation-card:nth-child(2) .card-description\n {\n  font-size: 1.2rem;\n  color: #555;\n  margin-top: -60%;\n}\n.homologation-card:nth-child(3) .card-description\n{\nfont-size: 1.2rem;\ncolor: #555;\nmargin-top: -100%;\n}\n.homologation-card:nth-child(4) .card-description\n{\nfont-size: 1.2rem;\ncolor: #555;\nmargin-top: -60%;\n}\n/* Mobile styles */\n@media (max-width: 768px) {\n  .homologation-cards {\n    flex-direction: column; /* Stack cards vertically */\n    padding: 60px 30px;\n  }\n\n  .homologation-card {\n    width: 100%; /* Full width for mobile */\n    height: auto; /* Adjust height automatically */\n    margin-bottom: 20px; /* Add spacing between cards */\n  }\n\n  .card-title {\n    font-size: 20px; /* Smaller text */\n  }\n\n  .card-description {\n    font-size: 16px;\n  }\n\n  .learn-more-btn {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n}\n\n/* Tablet styles */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .homologation-cards {\n    flex-wrap: wrap; /* Allow wrapping */\n    justify-content: center;\n  }\n\n  .homologation-card {\n    width: 45%; /* Adjust card width */\n    margin: 10px; /* Add spacing between cards */\n  }\n\n  .card-title {\n    font-size: 25px; /* Adjust text size */\n  }\n\n  .card-description {\n    font-size: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
